import Settings from './SettingsLazy'
export default Settings
